var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.177 18.3153C15.2868 18.3153 18.6185 14.9837 18.6185 10.8739C18.6185 6.76408 15.2868 3.43243 11.177 3.43243C7.06724 3.43243 3.7356 6.76408 3.7356 10.8739C3.7356 14.9837 7.06724 18.3153 11.177 18.3153Z",
    stroke: "#5C5470",
    strokeWidth: 3.18919,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4924 16.1891L22.8708 22.5675",
    stroke: "#5C5470",
    strokeWidth: 3.18919,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.1190ea7c950de9062e53f9c9c2849304.svg";
export { ForwardRef as ReactComponent };